'use strict';

angular.module('amexReconciliationApp').filter('bcaDisplayName',
  function () {
    return function bcaDisplayName (bca) {
      var bcaNumber = bca.bca;

      if(bca.bcaName) {
        return bcaNumber + ' (' + bca.bcaName + ')';
      }

      if(bca.description) {
        return bcaNumber + ' (' + bca.description + ')';
      }

      return bcaNumber;
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/filters/bcaDisplayName.js
// module id = 552
// module chunks = 0